import { TypedDocumentNode, gql } from '@apollo/client';
import { useState } from 'react';

import { DivisionChange } from '@sorare/core/src/__generated__/globalTypes';

import useMarkStoriesAsRead from '@sorare/gameplay/src/hooks/stories/useMarkStoriesAsRead';

import { Promoted } from './Promoted';
import { Relegated } from './Relegated';
import { Stable } from './Stable';
import { PromotionRelegationStory_footballRivalsPromotionRelegationStory } from './__generated__/index.graphql';

type Props = {
  story: PromotionRelegationStory_footballRivalsPromotionRelegationStory;
};
export const PromotionRelegationStory = ({ story }: Props) => {
  const [dismissed, setDismissed] = useState(false);
  const { readStories: markStoriesAsRead } = useMarkStoriesAsRead();

  if (dismissed) return null;

  const { divisionChange } = story;
  const onDismiss = () => {
    markStoriesAsRead({
      storyIds: [story.id],
    });
    setDismissed(true);
  };

  if (divisionChange === DivisionChange.PROMOTED) {
    return <Promoted story={story} onDismiss={onDismiss} />;
  }

  if (divisionChange === DivisionChange.RELEGATED) {
    return <Relegated story={story} onDismiss={onDismiss} />;
  }

  return <Stable story={story} onDismiss={onDismiss} />;
};

PromotionRelegationStory.fragments = {
  footballRivalsPromotionRelegationStory: gql`
    fragment PromotionRelegationStory_footballRivalsPromotionRelegationStory on FootballRivalsPromotionRelegationStory {
      id
      divisionChange
      ...Stable_footballRivalsPromotionRelegationStory
      ...Promoted_footballRivalsPromotionRelegationStory
      ...Relegated_footballRivalsPromotionRelegationStory
    }
    ${Stable.fragments.footballRivalsPromotionRelegationStory}
    ${Promoted.fragments.footballRivalsPromotionRelegationStory}
    ${Relegated.fragments.footballRivalsPromotionRelegationStory}
  ` as TypedDocumentNode<PromotionRelegationStory_footballRivalsPromotionRelegationStory>,
};
